import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Heading } from '@stepstone-genesis/components';
export const HeaderDescription = ({ label }) => {
    return (_jsx(Heading, { py: ['spaceS'], variant: 'heading4', fontWeight: 'fontWeightNormal', "data-testid": "header-description", children: label }));
};
//# sourceMappingURL=HeaderDescription.js.map